var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-form"},[_c('Authenticate',{attrs:{"registration":_vm.registration,"signin-button-text":_vm.signinButtonText},on:{"success":_vm.redirect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }